import request from "@/utils/request"


// 登录
export function login(data) {
    return request({
        method: 'post',
        url: 'api/userLogin',
        data: data
    })
}
// 注册
export function register(data) {
    return request({
        method: 'post',
        url: 'api/register',
        data: data
    })
}
// 用户信息
export function userInfo(data) {
    return request({
        method: 'get',
        url: 'api/userInfo',
        params: data
    })
}
// 首页数据
export function listFile(data) {
    return request({
        method: 'get',
        url: 'api/listFile',
        params: data
    })
}
// 常见问题
export function listQuestion(data) {
    return request({
        method: 'get',
        url: 'api/listQuestion',
        params: data
    })
}

// 提交反馈
export function pushQuestion(data) {
    return request({
        method: 'post',
        url: 'api/pushQuestion',
        data: data
    })
}
// 关于
export function getWeDetail(data) {
    return request({
        method: 'get',
        url: 'api/getWeDetail',
        params: data
    })
}
// 发送
export function createShare(data) {
    return request({
        method: 'get',
        url: 'api/createShare',
        params: data
    })
}
// 到期日期
export function setShareValidityData(data) {
    return request({
        method: 'get',
        url: 'api/setShareValidityData',
        params: data
    })
}

// 我的传输列表
export function listMyReceive(data) {
    return request({
        method: 'get',
        url: 'api/listMyReceive',
        params: data
    })
}
// 检查上传分片
export function checkChunk(data) {
    return request({
        method: 'get',
        url: 'api/check-chunk',
        params: data
    })
}

// 上传分片
export function uploadChunk(data) {
    return request({
        method: 'post',
        url: 'api/upload-chunk',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

// 通过密钥获取文件
export function listFileByCode(data) {
    return request({
        method: 'get',
        url: 'api/listFileByCode',
        params: data
    })
}

// 确认接收文件
export function confirmReceive(data) {
    return request({
        method: 'get',
        url: 'api/confirmReceive',
        params: data
    })
}
// 修改密码
export function updatePassWord(data) {
    return request({
        method: 'get',
        url: 'api/updatePassWord',
        params: data
    })
}


// 上传图片
export function upload(data) {
    return request({
        method: 'post',
        url: 'api/upload',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

// 修改个人信息
export function updateUser(data) {
    return request({
        method: 'get',
        url: 'api/updateUser',
        params: data
    })
}

// 文件删除
export function delFile(data) {
    return request({
        method: 'get',
        url: 'api/delFile',
        params: data
    })
}

// 获取系统设定的大小
export function getConfig(data) {
    return request({
        method: 'get',
        url: 'api/getConfig',
        params: data
    })
}





